// Apps > NFT Marketplace

// NFT Marketplace > Ranking
const rankinglist = [{
    id: 1,
    ranking: 1,
    img: require("@/assets/images/nft/img-01.jpg"),
    collection: "Abstract Face Painting",
    volume_price: "7,50,000",
    hours: 342.35,
    day: 312.35,
    item: "10k",
    floor_price: "33.02",
},
{
    id: 2,
    ranking: 2,
    img: "https://img.themesbrand.com/velzon/images/img-1.gif",
    collection: "Patterns Arts & Culture",
    volume_price: "32,850",
    hours: -42.03,
    day: 20.14,
    item: "8k",
    floor_price: "74.69",
},
{
    id: 3,
    ranking: 3,
    img: require("@/assets/images/nft/img-02.jpg"),
    collection: "Creative Filtered Portrait",
    volume_price: "1,36,000",
    hours: 170.31,
    day: -415.21,
    item: "15k",
    floor_price: "67.16",
},
{
    id: 4,
    ranking: 4,
    img: "https://img.themesbrand.com/velzon/images/img-2.gif",
    collection: "Long-tailed Macaque",
    volume_price: "3,63,000",
    hours: 709.13,
    day: -645.1,
    item: "21k",
    floor_price: "137.09",
},
{
    id: 5,
    ranking: 5,
    img: require("@/assets/images/nft/img-04.jpg"),
    collection: "Robotic Body Art",
    volume_price: "25,800",
    hours: -347.42,
    day: -321.17,
    item: "17k",
    floor_price: "343.75",
},
{
    id: 6,
    ranking: 6,
    img: require("@/assets/images/nft/img-06.jpg"),
    collection: "Smillevers Crypto",
    volume_price: "37,100",
    hours: 1.42,
    day: 0.64,
    item: "31k",
    floor_price: "1.87",
},
{
    id: 7,
    ranking: 7,
    img: "https://img.themesbrand.com/velzon/images/img-3.gif",
    collection: "The Chirstoper",
    volume_price: "1,87,600",
    hours: -31.49,
    day: 26.07,
    item: "18k",
    floor_price: "101.12",
},
{
    id: 8,
    ranking: 8,
    img: "https://img.themesbrand.com/velzon/images/img-3.gif",
    collection: "Walking On Air",
    volume_price: "4,62,000",
    hours: 238.13,
    day: 183.4,
    item: "8.3k",
    floor_price: "143.39",
},
{
    id: 9,
    ranking: 9,
    img: "https://img.themesbrand.com/velzon/images/img-5.gif",
    collection: "The Chirstoper",
    volume_price: "74,950",
    hours: -31.49,
    day: -26.07,
    item: "7.9k",
    floor_price: "101.12",
},
{
    id: 10,
    ranking: 10,
    img: require("@/assets/images/nft/img-03.jpg"),
    collection: "Walking On Air",
    volume_price: "3,35,750",
    hours: 238.13,
    day: -64.3,
    item: "8.3k",
    floor_price: "143.39",
},
{
    id: 11,
    ranking: 11,
    img: require("@/assets/images/nft/img-04.jpg"),
    collection: "Highstreet IHO Part",
    volume_price: "35,750",
    hours: 23.1,
    day: -64.36,
    item: "12.3k",
    floor_price: "367.39",
}];

export { rankinglist };